import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const SMALL_ELECTRIC_VEHICLE = {
  nickname: 'PRODUCTS.SMALL_ELECTRIC_VEHICLE.shortname',
  properties: [
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ACCIDENT_COVER', value: 'ACCIDENT_COVER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.LEGAL_SUPPORT_COVER', value: 'LEGAL_SUPPORT_COVER' },
        ]
      }
    },
    {
      name: 'vehicleType', key: 'VEHICLE_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.SCOOTER', value: 'SCOOTER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.TWO_WHEELER', value: 'TWO_WHEELER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.SKATEBOARD', value: 'SKATEBOARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.UNICYCLE', value: 'UNICYCLE' },
        ]
      }
    },
    {
      name: 'maximumWeight', key: 'MAXIMUM_WEIGHT', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'maxSpeed', key: 'MAX_SPEED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'maximumLength', key: 'MAXIMUM_LENGTH', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'commercialVehicle', key: 'COMMERCIAL_VEHICLE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
    },
    { name: 'serialNumber', key: 'SERIAL_NUMBER_SEV', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]],
    },
    { name: 'make', key: 'MAKE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
  ],
  icon:'small-electric-vehicle'
};
